import { RangeBars as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;
  let dateAccessor = (d) => d.date;
  let dateMutator = (d, date) => {
    d.date = date;
  };

  function calculator(data) {
    const { range, sourcePath } = options;
    const source = sourcePath ? (d) => d[sourcePath] : (d) => d.close;

    const bars = [];
    let bar = null;

    data.forEach((d) => {
      let price = source(d);

      // If no bar, start one
      if (!bar) {
        bar = {
          open: price,
          high: price,
          low: price,
          close: price,
          volume: d.volume,
          date: dateAccessor(d),
        };
        return;
      }

      // Process all price movement, possibly creating multiple bars
      while (true) {
        // Update high/low/close/volume
        bar.high = Math.max(bar.high, price);
        bar.low = Math.min(bar.low, price);
        bar.close = price;
        bar.volume += d.volume;

        // Check if range exceeded
        if (Math.abs(bar.close - bar.open) >= range) {
          // Determine direction
          const direction = bar.close > bar.open ? 1 : -1;
          // Set close to open +/- range
          bar.close = bar.open + direction * range;
          bar.high = Math.max(bar.open, bar.close);
          bar.low = Math.min(bar.open, bar.close);

          bars.push({ ...bar });

          // Start new bar from previous close
          bar = {
            open: bar.close,
            high: bar.close,
            low: bar.close,
            close: price,
            volume: 0,
            date: dateAccessor(d),
          };

          // If price still exceeds range, loop again
          if (Math.abs(price - bar.open) < range) break;
        } else {
          break;
        }
      }
    });

    if (bar) bars.push(bar);
    return bars;
  }

  calculator.options = function (x) {
    if (!arguments.length) return options;
    options = { ...defaultOptions, ...x };
    return calculator;
  };
  calculator.dateMutator = function (x) {
    if (!arguments.length) return dateMutator;
    dateMutator = x;
    return calculator;
  };
  calculator.dateAccessor = function (x) {
    if (!arguments.length) return dateAccessor;
    dateAccessor = x;
    return calculator;
  };

  return calculator;
}
